import { render } from "./BannerImage.vue?vue&type=template&id=296e34b2&scoped=true"
import script from "./BannerImage.vue?vue&type=script&lang=js"
export * from "./BannerImage.vue?vue&type=script&lang=js"

import "./BannerImage.vue?vue&type=style&index=0&id=296e34b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296e34b2"]])

export default __exports__